const API_BASE = "http://127.0.0.1:8000/api/monitoring/drip-sessions";

async function parseJson(response) {
  const text = await response.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return {};
  }
}

async function request(url, options = {}) {
  const response = await fetch(url, {
    method: options.method || "GET",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    body: options.body,
  });

  const data = await parseJson(response);

  if (!response.ok) {
    console.error("Drip session API error:", data);
    throw new Error(typeof data === "string" ? data : JSON.stringify(data));
  }

  return data;
}

export async function getDripSessions() {
  return request(`${API_BASE}/`);
}

export async function getDripSessionById(sessionId) {
  return request(`${API_BASE}/${sessionId}/`);
}

export async function createDripSession(payload) {
  return request(`${API_BASE}/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function pauseDripSession(sessionId) {
  return request(`${API_BASE}/${sessionId}/pause/`, {
    method: "POST",
  });
}

export async function resumeDripSession(sessionId) {
  return request(`${API_BASE}/${sessionId}/resume/`, {
    method: "POST",
  });
}

export async function stopDripSession(sessionId) {
  return request(`${API_BASE}/${sessionId}/stop/`, {
    method: "POST",
  });
}

export async function completeDripSession(sessionId) {
  return request(`${API_BASE}/${sessionId}/complete/`, {
    method: "POST",
  });
}